<div class="results-list">
	@if (actions().length > 0) {
		@for (action of actions(); let i = $index; track action.id) {
			<lowgile-result-item
				[action]="action"
				[isActive]="i === activeIndex()"
				[query]="query()"
				(select)="onActionSelect(action)"
			></lowgile-result-item>
		}
	}

	@if (!actions().length) {
		<div class="results-empty">
			<div class="results-empty-icon">🔍</div>
			<div class="results-empty-text">No actions found</div>
		</div>
	}
</div>
